import { render, staticRenderFns } from "./pay-slip2-pdf.vue?vue&type=template&id=7b8b5b48&scoped=true&"
import script from "./pay-slip2-pdf.vue?vue&type=script&lang=js&"
export * from "./pay-slip2-pdf.vue?vue&type=script&lang=js&"
import style0 from "./pay-slip2-pdf.vue?vue&type=style&index=0&id=7b8b5b48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8b5b48",
  null
  
)

export default component.exports